import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "multiple", "accept", "onChange", "onClick"];
import { useState, useCallback, Fragment } from 'react';
import { callIfValid } from '../utils/callIfValid';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilePickerInput = styled.input.withConfig({
  displayName: "VizExFileButton__FilePickerInput"
})(["display:none;"]);
const VizExFileButton = _ref => {
  let {
      children,
      multiple,
      accept = [],
      onChange,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [fileInputEl, setFileInputEl] = useState(null);
  const handleClick = useCallback(evt => {
    fileInputEl === null || fileInputEl === void 0 || fileInputEl.click();
    callIfValid(onClick, evt);
  }, [fileInputEl, onClick]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [children({
      onClick: handleClick
    }), /*#__PURE__*/_jsx(FilePickerInput, Object.assign({}, rest, {
      ref: setFileInputEl,
      type: "file",
      accept: accept.join(','),
      multiple: multiple,
      onChange: onChange
    }))]
  });
};
VizExFileButton.displayName = 'VizExFileButton';
export default VizExFileButton;